import React from "react";

export default function Contact() {
  return (
    <section id="contact" className="bg-gray-100 py-16 px-6">
      <h2 className="text-3xl font-bold text-center text-blue-600 mb-8">Contact</h2>
      <div className="max-w-md mx-auto text-center">
        <p className="text-lg mb-4">Connect with me on:</p>
        <div className="flex justify-center gap-6">
          <a href="https://wa.me/254724899116" className="text-green-600 font-medium hover:underline">WhatsApp</a>
          <a href="https://linkedin.com/in/daniel-mirigi" className="text-blue-600 font-medium hover:underline">LinkedIn</a>
          <a href="mailto:danmiriri@gmail.com" className="text-gray-800 font-medium hover:underline">Email</a>
        </div>
      </div>
    </section>
  );
}
